module.exports = __webpack_public_path__ + "static/media/09-bgimg@3x.fee87c19.webp";